import React from 'react';
import { elementType } from 'prop-types';
import { styled } from '@mui/material/styles';
import { square } from '../../internals/utils/stylesHelpers';
const SupportMenuIcon = _ref => {
  let {
    element
  } = _ref;
  const StyledElement = styled(element)(_ref2 => {
    let {
      theme: {
        palette,
        spacing
      }
    } = _ref2;
    return {
      color: palette.primary.main,
      ...square(spacing(3)),
      '& path': {
        fill: palette.text.secondary
      }
    };
  });
  return /*#__PURE__*/React.createElement(StyledElement, null);
};
SupportMenuIcon.propTypes = {
  element: elementType.isRequired
};
export default SupportMenuIcon;